import { updateArrayItem } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    integrationToEdit: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList"]),
    isEdit() {
      return !!this.integrationToEdit?.id;
    },
    isValid() {
      return false;
    }
  },
  methods: {
    onSuccess({ data }) {
      this.$emit("close");
      this.$message.success("A integração foi salva!");

      if (this.isEdit) {
        this.$store.commit(
          "integration/setIntegrationList",
          updateArrayItem(this.integrationList, data)
        );
      } else {
        this.$emit("update-list");
      }
    },
    submit() {
      this.loading = true;

      let data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.isEdit) {
        action = "integration/putIntegration";
        data.id = this.integrationToEdit.id;
      } else {
        data.status = true;
      }

      this.$store
        .dispatch(action, data)
        .then(this.onSuccess)
        .catch(error => {
          this.$message.error(
            error.response?.data.message || "Erro ao salvar integração."
          );
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
